import * as moment from 'moment';
import {database, auth} from '../firebase';

export const performFinalizePayment = async data => {
    try{
        await database.collection("companies").doc(data.companyId).collection("payment").doc("stripe").set({customerId: data.customerId, sessionId: data.sessionId, subscriptionId: data.subscriptionId, timestamp: data.timestamp, amount: data.amount})
        await database.collection("companies").doc(data.companyId).update({status: "active"})
        await database.collection("users").doc(auth.currentUser.uid).collection("companies").doc(data.companyId).set({dateAdded: moment().unix()})
        return {error: null, payload: "success"}
    } catch(e) {
        throw new Error(e)
    }
}